import { render, staticRenderFns } from "./GOOGLELoginButton.vue?vue&type=template&id=0d8ed814&scoped=true&"
import script from "./GOOGLELoginButton.vue?vue&type=script&lang=js&"
export * from "./GOOGLELoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8ed814",
  null
  
)

export default component.exports